import { Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect } from "react";
import {
    APIS,
    PGEUIDS,
    SF_AUTH_SRCH,
    SG_AUTH_LIST,
    SG_MENU_LIST,
} from "@/tz/go/egaz/osci/ptl/ptl/auth/services/OsciRoleAuthService";
import { comnUtils } from "@/comn/utils";

/*
 * Menu and Screen List Popup
 * !== 메뉴 및 화면 목록 팝업 ==!
 */
export const OSCI0104018Q = (props: any) => {
    const { callback, roleAuthList, roleId, ptlTpCd } = props;

    const { pgeUid } = usePage({ pgeUid: PGEUIDS.osci0104018q });
    const modal = useModal();
    const toast = useToast();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0088" },
            { area: "comnCd", comnCd: "OSC0095" },
        ],
    });

    const form = {
        authSrch: useForm({ defaultSchema: SF_AUTH_SRCH, defaultValues: pgeStore?.form || {} }),
    };

    const grid = {
        authList: useGrid({
            defaultSchema: SG_AUTH_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        menuList: useGrid({ defaultSchema: SG_MENU_LIST }),
    };

    const fetch = {
        getAuthList: useFetch({
            api: (page = grid.authList.page, size = grid.authList.size) =>
                APIS.getAuthList(form.authSrch.getValues(), page, size),
            enabled: comnUtils.isEmpty(form.authSrch.errors),
            key: [grid.authList.page, grid.authList.size],
            onSuccess: (data: any) => {
                data.authList.content.forEach((item: any, index: number) => {
                    if (roleAuthList.findIndex((subItem: any) => item.authId === subItem.authId) > -1) {
                        item = { ...item, roleId: roleId };
                        data.authList.content = data.authList.content.with(index, item);
                    }
                });

                grid.authList.setData(data.authList);

                setStore(pgeUid, {
                    form: form.authSrch.getValues(),
                    page: grid.authList.page,
                    size: grid.authList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        getMenuList: useFetch({
            api: (data: any) => APIS.getMenuList(data),
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const handler = {
        onSrchBtnClick: form.authSrch.handleSubmit(
            () => {
                grid.menuList.clearData();
                grid.authList.setPage(0);
                fetch.getAuthList.fetch(0);
            },
            () => {
                modal.openModal({ content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
            },
        ),
        onApplyBtnClick: () => {
            if (!grid.authList.isChecked()) {
                modal.openModal({ content: "msg.osc.00197" }); // 등록대상을 선택하세요.
                return;
            }
            callback(grid.authList.getChecked());
        },
        onMenuGridCellClick: (cell: any) => {
            fetch.getMenuList.fetch(cell.rowValues);
        },
    };

    const render = { authList: { checkbox: (rowValues: any) => roleId === "new" || rowValues.roleId != roleId } };

    useEffect(() => {
        form.authSrch.setEditable("ptlTpCd", false);
        form.authSrch.setValue("ptlTpCd", ptlTpCd);
    }, []);

    return (
        <Page pgeUid={pgeUid} info={true}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.authSrch.schema.authId} />
                            <Group.Control {...form.authSrch.schema.authNm} />
                        </Group.Row>
                    </Group.Section>

                    <Layout>
                        <Layout.Right>
                            <Layout.Button role={"search"} onClick={handler.onSrchBtnClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Layout direction={"row"}>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Grid
                                {...grid.authList.grid}
                                render={render.authList}
                                onCellClick={handler.onMenuGridCellClick}
                            />
                        </Group.Section>
                    </Group.Body>
                </Group>

                <Group>
                    <Group.Body>
                        <Group.Section>
                            {" "}
                            <Grid {...grid.menuList.grid} data={fetch.getMenuList.data?.menuList} />{" "}
                        </Group.Section>
                    </Group.Body>
                </Group>
            </Layout>

            <Layout>
                <Layout.Right>
                    <Layout.Button role={"apply"} onClick={handler.onApplyBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
